import * as Wizard from '#~/agent/components/wizard/index.js';
import { EVENT_CATEGORIES, EVENT_NAMES, useAnalytics } from '#~/analytics/index.js';
import { useHasSeenAgentSetup } from '#~/room/hook_last_id.js';
import { Paths } from '#~/routes/index.js';
import { Anchor } from '@studio/design-system/button';
import { useMount } from '@studio/react-utils/hooks';
import { vendorName } from '@studio/design-system/themes/vendor.js';
import type { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../../icon.jsx';

/** `<Setup>` component. */
export const Setup = (): ReactElement => {
  const navigate = useNavigate();
  const [, setHasSeenAgentSetup] = useHasSeenAgentSetup();
  const { track } = useAnalytics();

  // Track start_download_flow event on mount
  useMount(() => {
    track(EVENT_NAMES.START_DOWNLOAD_FLOW, EVENT_CATEGORIES.ONBOARDING);
  });

  return (
    <Wizard.Root currentStep={1} totalSteps={4}>
      <Icon />

      <Wizard.Verbiage
        message='This allows you to discover NDI, RTSP, and IP video sources and control your cameras. It also enables the use of our auto-tracking functionality.'
        title={`Download & install the ${vendorName()} Bridge`}
      />

      <Wizard.ButtonBox>
        <Wizard.Button
          onClick={(): void => {
            navigate(`/${Paths.agent.setup.select}`);
          }}
        >
          Continue &raquo;
        </Wizard.Button>

        <Anchor
          className='mt-auto text-primary'
          onClick={(): void => {
            setHasSeenAgentSetup(true);
            navigate(`/${Paths.agent.setup.link}`);
          }}
        >
          Already installed the {vendorName()} Bridge?
        </Anchor>
      </Wizard.ButtonBox>
    </Wizard.Root>
  );
};
